<script setup lang="ts">
import {label} from "../../mixins/translations";
import Modal from "../Modal.vue";

const emit = defineEmits<(e: 'close') => void>();
const updateOpen = (open) => {
    if(!open){
        emit('close');
    }
};
</script>

<template>
    <Modal @updateOpen="updateOpen" :open="true" >
        <template #trigger-wrapper>&nbsp;</template>
        <template #title>
            {{ label('site.no_account.title') }}
        </template>
        <template #description>
            <div class="text-center md:text-left text-lg py-4" v-html="label('site.no_account.content')">
            </div>
            <div class="flex flex-row gap-4">
                <a href="/login/" class="mt-4 lg:mt-0 w-auto py-3 px-6 bg-primary-500 text-white uppercase tracking-wider font-medium text-center">
                    {{ label('site.button.login') }}
                </a>

                <a href="/register/" class="mt-4 lg:mt-0 w-auto py-3 px-6 bg-secondary-500 text-white uppercase tracking-wider font-medium text-center">
                    {{ label('site.button.register') }}
                </a>
            </div>
        </template>
    </Modal>
</template>
